import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../components/01_config/api";


// const API_URL = "http://localhost:4000";

// Adjust body keys here if your backend expects different names
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async ({ email, password }, { rejectWithValue }) => {

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 45000); // 15s

    try {

      const body = new URLSearchParams({
        email,
        username: email,   // optional safety if backend expects username
        password,
      }).toString();

      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        // body,
        body,
        // body: JSON.stringify({ email, password }),
        signal: controller.signal,
      });

      if (!res.ok) {
        let data = {}
        try {
          data = await res.json()
        } catch (e) { }
        if (res.status === 429) {
          return rejectWithValue("Too many login attempts. Please try again in 15 minutes.")
        }
        if (res.status === 403) {
          const msg = data.error || "Your account has been disabled.";
          return rejectWithValue(msg);
        }
        if (res.status === 400 || res.status === 401) {
          return rejectWithValue("Credentials not correct.")
        }
        return rejectWithValue("Server error. Please try again.")
      }

      const data = await res.json(); // { token, user }
      try {
        localStorage.setItem("tl_token", data.token);
        localStorage.setItem("tl_user", JSON.stringify(data.user));
      } catch { }
      return data;
    } catch (err) {
      if (err.name === "AbortError") {
        return rejectWithValue(
          "Login timed out. Please check your connection and try again."
        );
      }
      return rejectWithValue("Network error, please try again.");
    } finally {
      clearTimeout(timeoutId); // ✅ CLEANUP
    }
  }
);



// optional: simple register (no auto-login here)
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async ({ username, email, password }, { rejectWithValue }) => {
    try {
      const res = await fetch(`${API_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, email, password }),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        const message = errorData.message || "Signup failed";
        return rejectWithValue(message);
      }

      const data = await res.json();
      return data; // whatever your backend returns
    } catch (err) {
      return rejectWithValue("Network error, please try again.");
    }
  }
);

// const initialToken = localStorage.getItem("tl_token");
// const initialUser = localStorage.getItem("tl_user");

let initialToken = null;
let initialUser = null;
try {
  initialToken = localStorage.getItem("tl_token");
  initialUser = localStorage.getItem("tl_user");
} catch { }



const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: initialToken || null,
    // user: initialUser ? JSON.parse(initialUser) : null,
    user: (() => {
      if (!initialUser) return null;
      try { return JSON.parse(initialUser); } catch { return null; }
    })(),
    loading: false,
    error: null,
    lastSignupSuccess: false,
    justLoggedIn: false,
  },
  reducers: {
    logout(state) {
      state.token = null;
      state.user = null;
      state.error = null;
      // localStorage.removeItem("tl_token");
      // localStorage.removeItem("tl_user");
      try {
        localStorage.removeItem("tl_token");
        localStorage.removeItem("tl_user");
      } catch { }
    },
    clearAuthError(state) {
      state.error = null;
    },
    clearSignupSuccess(state) {
      state.lastSignupSuccess = false;
    },
    clearJustLoggedIn(state) {
      state.justLoggedIn = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // login
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        state.user = action.payload.user;
        state.error = null;
        state.justLoggedIn = true;

        // localStorage.setItem("tl_token", action.payload.token);
        // localStorage.setItem("tl_user", JSON.stringify(action.payload.user));
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
      })
      // signup
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.lastSignupSuccess = false;
      })
      .addCase(registerUser.fulfilled, (state) => {
        state.loading = false;
        state.lastSignupSuccess = true;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Signup failed";
        state.lastSignupSuccess = false;
      });
  },
});

export const { logout, clearAuthError, clearSignupSuccess, clearJustLoggedIn, } = authSlice.actions;

export default authSlice.reducer;
